import BasicLayout from '@/components/layout/BasicLayout'

export default {
  props: {
    hideFooter: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.$parent.$emit('layout', {
      layout: BasicLayout,
      props: {
        hideFooter: this.hideFooter,
      },
    })
  },
  render() {
    return this.$slots.default[0]
  },
}
